import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addCountry,
  deleteCountry,
  getCountry,
  updateCountry,
  updateDefaultCountry,
} from "store/services/dataManagement/country";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All country
export const GetAllCountryAction = createAsyncThunk(
  "country/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getCountry(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete country
export const DeleteCountryAction = createAsyncThunk(
  "country/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await deleteCountry(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        const responce = await getCountry(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Update country
export const UpdateCountryAction = createAsyncThunk(
  "country/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await updateCountry(rest);
      if (res.status === 1) {
        dispatch(closeAdminModal());
        dispatch(GetAllCountryAction());
        if (onSuccess) onSuccess();
        return fulfillWithValue(res);
      }

      if (onError) onError();

      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(res?.statusCode),
        }),
      );

      return rejectWithValue({ message: res?.message });
    } catch (error) {
      if (onError) onError();

      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );

      return rejectWithValue(error);
    }
  },
);

//Update country
export const UpdateDefaultCountryAction = createAsyncThunk(
  "country/updateDefault",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await updateDefaultCountry(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Add country
export const AddCountryAction = createAsyncThunk(
  "country/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;

    try {
      const res = await addCountry(rest);

      if (res.status === 1) {
        dispatch(closeAdminModal());
        dispatch(GetAllCountryAction());

        if (onSuccess) onSuccess();

        return fulfillWithValue(res);
      }

      if (onError) onError();

      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(res?.statusCode),
        }),
      );

      return rejectWithValue({ message: res?.message });
    } catch (error) {
      if (onError) onError();

      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );

      return rejectWithValue(error);
    }
  },
);

